/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Pulse_Demo_WeekInputs */



/**
* | output |
* | --- |
* | "This week" |
*
* @param {Products_Pulse_Demo_WeekInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_pulse_demo_week = /** @type {((inputs?: Products_Pulse_Demo_WeekInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Pulse_Demo_WeekInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Эта неделя")
	return /** @type {LocalizedString} */ ("This week")
});